import { useDrugProgram } from '../contexts/DrugProgramProvider';
import type {
    AuthorizedMedicationInfoFragment,
    MedicationInfoFragment,
    UnknownMedicationInfoFragment,
} from '../graphql/generated/graphql';
import { getDrugConfigByNdc } from '../util/config/get-drug-config-by-medication';

import { getNdc } from './use-medication-pricing';

type MedicationParam =
    | AuthorizedMedicationInfoFragment
    | MedicationInfoFragment
    | UnknownMedicationInfoFragment;

export const useDrugKey = (medication: MedicationParam) => {
    const drugProgram = useDrugProgram();
    const ndc = getNdc(medication);
    const drugConfig = getDrugConfigByNdc(drugProgram, ndc);

    return drugConfig?.drugKey ?? null;
};
